'use client'
import { useMemoizedContentGetter } from 'utils/contentful'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { Grid } from '@achieve/ascend'
import Section from 'components/Section'
import classNames from 'classnames'

const ImageGridSection = ({ content }) => {
  const memoizedContent = useMemoizedContentGetter(content, [
    'preHeading',
    'heading',
    'subHeading',
    'mainCopy',
    'gridImage',
  ])

  const { preHeading, heading, subHeading, mainCopy, gridImage } = memoizedContent

  return (
    <Section contain={false} childContainerClassName={'px-0'}>
      <Grid
        container
        spacing={{ xxs: 0, lg: 4 }}
        textAlign="center"
        justifyContent="flex-end"
        data-testid="member-stories-image-grid-container"
        className="flex-col lg:flex-row"
      >
        <Grid size={{ xxs: 12, lg: 6 }}>
          <div className={'px-0 py-8 lg:px-0 lg:py-16'}>
            {preHeading?.textContent && (
              <div className={'mb-4'}>
                <Typography
                  data-testid="member-stories-image-grid-pre-heading"
                  content={preHeading.textContent}
                  variant="headingMd"
                  fontWeight="medium"
                  component="p"
                />
              </div>
            )}
            {heading?.textContent && (
              <div className={'mb-4'}>
                <Typography
                  data-testid="member-stories-image-grid-heading"
                  content={heading?.textContent}
                  component="h3"
                  className="headingLg lg:displayXl font-bold!"
                />
              </div>
            )}
            {subHeading?.textContent && (
              <div className={'mb-6'} data-testid="member-stories-image-grid-sub-heading-container">
                <Typography
                  data-testid="member-stories-image-grid-sub-heading"
                  content={subHeading?.textContent}
                  variant="headingMd"
                  fontWeight="medium"
                  component="p"
                />
              </div>
            )}
            {mainCopy?.textContent && (
              <div className={'pl-4 pr-4 md:pl-8 md:pr-8'}>
                <Typography
                  data-testid="member-stories-image-grid-main-copy"
                  content={mainCopy?.textContent}
                  variant="bodySm"
                  fontWeight="normal"
                  component="p"
                  lineHeight="170%" // TODO alert and update ascend
                />
              </div>
            )}
          </div>
        </Grid>

        {gridImage?.mediaContent ? (
          <Grid size={{ xxs: 5 }} container justifyContent="flex-end" className="hidden lg:flex">
            <div
              className={classNames(
                'relative w-full h-full lg:max-w-[465px] lg:max-h-[465px]',
                '[&_img]:h-full [&_img]:w-full lg:max-w-[465px] lg:max-h-[465px]'
              )}
            >
              <MediaImageStandard
                alt={gridImage?.mediaAltText || 'grid-image'}
                content={gridImage?.mediaContent}
              />
            </div>
          </Grid>
        ) : null}

        {gridImage?.mobileMediaContent ? (
          <Grid size={{ xxs: 12 }} container className="flex lg:hidden">
            <div
              className={classNames(
                'relative w-full h-full lg:max-w-[465px] lg:max-h-[465px]',
                '[&_img]:h-full [&_img]:w-full lg:[&_img]:max-w-[465px] lg:[&_img]:max-h-[465px]'
              )}
            >
              <MediaImageStandard
                alt={gridImage?.mediaAltText || 'grid-image-mobile'}
                content={gridImage?.mobileMediaContent}
              />
            </div>
          </Grid>
        ) : null}
      </Grid>
    </Section>
  )
}
export { ImageGridSection }
export default ImageGridSection
